export default "__VITE_ASSET__QV9_7m91__"